import { useEffect, useState } from "react";
import axios from "axios";
import { useGlobalContext } from "../../../../../Context/Context";

const styles = {
  cell: {
    padding: "5px",
    textAlign: "center",
    fontSize: "12px",
    width: "50%",
    whiteSpace: "pre-line"
  }
};

const razloziMapping = {
  "01": "приликом заснивања радног односа, односно другог радног ангажовања",
  "02": "услед премештаја на друге послове",
  "03": "приликом увођења нове технологије или нових средстава за рад или промене опреме за рад",
  "04": "приликом промене радног процеса",
  "05": "ако послодавац одреди запосленом да обавља послове на два или више радних места",
  "06": "ако код послодавца (на основу уговора, споразума или по било ком другом основу) рад обављају запослени другог послодавца",
  "07": "додатна обука када то захтева радни процес",
  "08": "додатна обука у случају тешке, смртне или колективне повреде на раду са тешком или смртном повредом на раду",
  "09": "периодична обука запослених",
  10: "обука непосредних руководилаца"
};

function Obrazac6Prikaz({ data }) {
    console.log("LZO u prikazu:", data.lzo);

    const { selectedMainEntity, baseUrl, loggedUser, apiKey } = useGlobalContext();
const [header, setHeader] = useState({ name: "", address: "", pib: "" });

useEffect(() => {
  const fetchHeader = async () => {
    const id = selectedMainEntity?.company_id || selectedMainEntity?.id;
    if (!id || !loggedUser?.id) return;
    try {
      const { data: res } = await axios.post(`${baseUrl}/companies/readCompanyDetails.php`, {
        user_id: loggedUser.id,
        api_key: apiKey,
        company_id: id,
      });
      if (res.status === 200) setHeader({
        name: res.data.company_name,
        address: res.data.company_address,
        pib: res.data.pib
      });
    } catch (e) { console.error(e); }
  };
  fetchHeader();
}, [selectedMainEntity, loggedUser?.id]);

  return (
    <>
      <div style={{ fontWeight: "bold", textAlign: "center" }}>
        <div>Образац 6</div>
        <div>
          ЕВИДЕНЦИЈА О ЗАПОСЛЕНИМА ОБУЧЕНИМ ЗА БЕЗБЕДАН И ЗДРАВ РАД И ПРАВИЛНО
          КОРИШЋЕЊЕ ЛИЧНЕ ЗАШТИТНЕ ОПРЕМЕ
        </div>
      </div>
      <br />
      <br />

      <div style={{ display: "flex" }}>
        <div style={{ width: "33%", textAlign: "center" }}>
          {header.name}
          <hr style={{ width: "80%", margin: "0 auto", marginBottom: "5px" }} />
          Пословно име послодавца
        </div>
        <div style={{ width: "33%", textAlign: "center" }}>
          {header.address}
          <hr style={{ width: "80%", margin: "0 auto", marginBottom: "5px" }} />
          Адреса седишта послодавца
        </div>
        <div style={{ width: "33%", textAlign: "center" }}>
          {header.pib}
          <hr style={{ width: "80%", margin: "0 auto", marginBottom: "5px" }} />
          ПИБ послодавца
        </div>
      </div>
      <br />
      <br />

      <table>
        <tr>
          <td colSpan={1} style={{ ...styles.cell, width: "25%" }}>
            Име и презиме
          </td>
          <td
            colSpan={3}
            style={{
              ...styles.cell,
              width: "75%",
              fontWeight: "bold",
              textTransform: "uppercase"
            }}
          >
            {data.zaposlen?.name}
          </td>
        </tr>
        <tr>
          <td colSpan={1} style={{ ...styles.cell, width: "25%" }}>
            Назив радног места
          </td>
          <td
            colSpan={3}
            style={{
              ...styles.cell,
              width: "75%",
              fontWeight: "bold",
              textTransform: "uppercase"
            }}
          >
            {data.radnoMesto?.name}
          </td>
        </tr>
        <tr>
          <td colSpan={1} style={{ ...styles.cell, width: "25%" }}>
            Опис послова на том радном месту
          </td>
          <td
            colSpan={3}
            style={{ ...styles.cell, width: "75%", textAlign: "left" }}
          >
            {data.opis}
          </td>
        </tr>
        <tr>
          <td colSpan={2} style={styles.cell}>
            Случај, односно разлог извршене обуке запосленог за безбедан и здрав
            рад
          </td>
          <td colSpan={2} style={styles.cell}>
            <span style={{ fontWeight: "bold" }}>{data.razlog}</span>
            <span> - {razloziMapping[data.razlog] || ""}</span>
          </td>
        </tr>
        <tr>
          <td colSpan={2} style={styles.cell}>
            Датум обуке за безбедан и здрав рад
          </td>
          <td colSpan={2} style={styles.cell}>
            Датум провере обучености за безбедан и здрав рад
          </td>
        </tr>
        <tr>
          <td style={{ ...styles.cell, width: "25%" }}>теоријске</td>
          <td style={{ ...styles.cell, width: "25%" }}>практичне</td>
          <td style={{ ...styles.cell, width: "25%" }}>теоријске</td>
          <td style={{ ...styles.cell, width: "25%" }}>практичне</td>
        </tr>
        <tr style={{ fontWeight: "bold" }}>
          <td style={{ ...styles.cell, width: "25%" }}>{data.teorijaDatum}</td>
          <td style={{ ...styles.cell, width: "25%" }}>{data.praksaDatum}</td>
          <td style={{ ...styles.cell, width: "25%" }}>{data.testDatum}</td>
          <td style={{ ...styles.cell, width: "25%" }}>{data.zapisnikDatum}</td>
        </tr>
        <tr>
          <td colSpan={3} style={{ ...styles.cell, width: "25%" }}>
            Назив личне заштитне опреме (ако је коришћење ЛЗО утврђено актом о
            процени ризика)
          </td>
          <td colSpan={1} style={{ ...styles.cell, width: "75%" }}>
            Датум обуке за правилно коришћење личне заштитне опреме
          </td>
        </tr>
        <tr>
          <td colSpan={3} style={{ ...styles.cell, width: "75%" }}>
            {data.lzo.map((rm) => rm.naziv).join(", ")}
          </td>
          <td
            colSpan={1}
            style={{ ...styles.cell, width: "25%", fontWeight: "bold" }}
          >
            {data.lzoDatum}
          </td>
        </tr>
        <tr>
          <td colSpan={1} style={{ ...styles.cell, width: "25%" }}>
            Опасности, односно штетности са којима је запослени упознат приликом
            обуке за безбедан и здрав рад
          </td>
          <td
            colSpan={3}
            style={{ ...styles.cell, width: "75%", textAlign: "left" }}
          >
            {data.rizici}
          </td>
        </tr>
        <tr>
          <td colSpan={1} style={{ ...styles.cell, width: "25%" }}>
            Конкретне мере за безбедан и здрав рад на том радном месту
          </td>
          <td
            colSpan={3}
            style={{ ...styles.cell, textAlign: "left", width: "75%" }}
          >
            {data.mere.map((mera) => (
              <div key={mera.id} style={{ marginBottom: "7px" }}>
                <div
                  style={{
                    fontWeight: "bold",
                    textAlign: "center"
                  }}
                >
                  <i>
                    <u>{mera.title}</u>
                  </i>
                </div>
                <div>{mera.text}</div>
              </div>
            ))}
          </td>
        </tr>
        <tr>
          <td colSpan={1} style={{ ...styles.cell, width: "25%" }}>
            Називи радних места које руководилац прати и контролише
          </td>
          <td colSpan={3} style={{ ...styles.cell, width: "75%" }}>
            {data.prati.map((rm) => rm.name).join(", ")}
          </td>
        </tr>
        <tr>
          <td colSpan={1} style={{ ...styles.cell, width: "25%" }}>
            Обавештења, упутства или инструкције са којима је запослени упознат
            ради обављања процеца рада на безбедан начин
          </td>
          <td
            colSpan={3}
            style={{ ...styles.cell, width: "75%", textAlign: "left" }}
          >
            {data.uputstva}
          </td>
        </tr>
      </table>

      <br />
      <br />

      <div style={{ display: "flex" }}>
        <div style={{ width: "70%", textAlign: "center" }}>
          <hr style={{ width: "80%", margin: "0 auto", marginBottom: "5px" }} />
          Саветник/сарадник за безбедност и здравље на раду
        </div>
        <div style={{ width: "30%", textAlign: "center" }}>
          <hr style={{ width: "80%", margin: "0 auto", marginBottom: "5px" }} />
          Послодавац
        </div>
      </div>
      <br />
      <br />
      <div style={{ display: "flex" }}>
        <div style={{ width: "70%", textAlign: "center" }}>
          <hr style={{ width: "80%", margin: "0 auto", marginBottom: "5px" }} />
          Запослени
        </div>
      </div>
    </>
  );
}

export default Obrazac6Prikaz;
